
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import departmentModule from '../../../store/modules/departments'

@Component
export default class ProjectSheets extends Vue {
    @Prop()
    sequenceId !: any
    showFilter = false
    tableOptions:Array<any> = []
    projectProperties = [
        {
            key:"sn",
            tdClass: 'project-report-table',
            label:"S/N",
            stickyColumn:true
        },
        {
            key:"name",
            label:"Project Name",
            stickyColumn:true,
            tdClass: 'project-report-table',
        },
        {
            key:"wellName",
            label:"Well Name",
            sortByFormatted:true,
            tdClass: 'project-report-table',
            sortable:true,
            stickyColumn:true,
            formatter: (value:any,key:any,item:any) => {
                return item.well.name
            }
        },
        {
            key:"projectType",
            label:"Category",
        },
        {
            key:"rigName",
            label:"Rig",
            tdClass: 'project-report-table',
        },
        {
            key:"funding",
            label:"Funding",
            tdClass: 'project-report-table',
        },
        {
            key:"wellType",
            label:"Well Fluid",
            tdClass: 'project-report-table',
        },
        {
            key:"budgetYear",
            label:"Budget Year",
            sortable:true,
            tdClass: 'project-report-table',
            sortByFormatted:true,
            formatter: (value:any,key:any,item:any) => {
                return Number.parseInt(item.start.split('-')[0])
            }
        },
        {
            key:"field",
            label:"Field",
            tdClass: 'project-report-table',
        },
        {
            key:"location",
            label:"Location",
            tdClass: 'project-report-table',
            formatter:(value:any,key:any,item:any) => {
                return item.well ? item.well.location : 'Not defined';
            }
        },
        {
            key:"terrain",
            label:"Terrain",
            tdClass: 'project-report-table',
            formatter:(value:any,key:any,item:any) => {
                return item.well ? item.well.terrain : 'Not defined';
            }
        },
        {
            key:"wellConfig",
            label:"Well Config",
            tdClass: 'project-report-table',
            formatter:(value:any,key:any,item:any) => {
                return item.well ? item.well.wellConfiguration : 'Not defined';
            }
        },
        {
            key:"start",
            label:"Start",
            tdClass: 'project-report-table',
        },
        {
            key:"end",
            label:"End",
            tdClass: 'project-report-table',
        },
        {
            key:"duration",
            label:"Duration(days)",
            tdClass: 'project-report-table',
            sortable:true,
            sortByFormatted:true,
            formatter: (value:any,key:any,item:any) => {
                let date1:any = new Date(item.start)
                let date2: any = new Date(item.end)
                let timeDifference = Math.abs(date2 - date1)
                let duration = Math.ceil(timeDifference/(1000*60*60*24))
                return duration
            }
        },
        {
            key:"norminalDepth",
            label:"Norminal Depth(m)",
            tdClass: 'project-report-table',
            formatter: (value:any,key:any,item:any) => {
                return item.well ? item.well.normDepth : 'Not defined';
            }
        },
        {
            key:"trueDepth",
            label:"True Depth(m)",
            tdClass: 'project-report-table',
            formatter: (value:any,key:any,item:any) => {
                return item.well ? item.well.trueDepth : 'Not defined';
            }
        },
    ]
    selectedFields: Array<any> = []
    selectedProjects: Array<any> = []
    selectedFundingTranches: Array<any> = []

    get fundings () {
        return this.$store.getters['fundingsModule/getFundings']
    }

    get fundingOptions () {
        const fundingOptionsToReturn = this.fundings.map((f:any) => ({text: f.name, value: f.id}))
        fundingOptionsToReturn.push({value:"UNDEFINED",text:"Not Specified"})
        return fundingOptionsToReturn
    }

    get projectTableFields():Array<any>{
        let fieldsToReturn:Array<any> = []
        fieldsToReturn.push(...this.projectProperties.filter(p=>this.selectedFields.includes(p.key)))

        this.sequence.departments.forEach((d:any,di:any,allDepts:Array<any>) => {
            let showDeptSum = this.selectedFields.includes('d'+d.id)
            d.operationUnits.filter((t:any)=>this.selectedFields.includes('t'+t.id)).forEach((t:any,i:any,allOperations:Array<any>) => {
                fieldsToReturn.push({
                    key:"t"+t.id,
                    label:t.name + "(K$)",
                    tdClass: 'project-report-table',
                    hasMainHeader:di==0&&i==0,
                    skipMainHeader:di!=0,
                    mainHeader:"Approved Budget",
                    mainHeaderSpan:allDepts.reduce((a:any,b:any) => (a + b.operationUnits.filter((iit:any)=>this.selectedFields.includes('t'+iit.id)).length),0)+allDepts.filter((iid:any) => this.selectedFields.includes('d'+iid.id)).length,
                    hasHeader:i==0,
                    skipHeader:i!=0,
                    header:d.name,
                    headerSpan:showDeptSum? (allOperations.length+1):allOperations.length,
                    formatter:(value:any,key:any,item:any) => {
                        let totalBudget = 0
                        item.activities.filter((a:any) => a.operationUnitId == t.id).forEach((a:any) => {
                            if(a.budget){
                                a.budget.budgetLines.forEach((budgetLine:any) => {
                                    totalBudget+=budgetLine.lineValue
                                })
                            }
                        });
                        return totalBudget
                    }
                })
            })
            if(showDeptSum){
                fieldsToReturn.push({
                    key:"d"+d.id,
                    label:d.name + " Sum (K$)",
                    skipHeader:true,
                    skipMainHeader:true,
                    tdClass: 'project-report-table',
                    formatter:(value:any,key:any,item:any) => {
                        let totalBudget = 0
                        item.activities.filter((a:any) => a.departmentId == d.id).forEach((a:any) => {
                            if(a.budget){
                                a.budget.budgetLines.forEach((budgetLine:any) => {
                                    totalBudget+=budgetLine.lineValue
                                })
                            }
                        });
                        return totalBudget
                    }
                })
            }
        })
        
        this.sequence.departments.forEach((d:any,di:any,allDepts:Array<any>) => {
            let showDeptSum = this.selectedFields.includes('rbd'+d.id)
            d.operationUnits.filter((t:any)=>this.selectedFields.includes('rbt'+t.id)).forEach((t:any,i:any,allOperations:Array<any>) => {
                fieldsToReturn.push({
                    key:"rbt"+t.id,
                    label:t.name + "(K$)",
                    tdClass: 'project-report-table',
                    hasMainHeader:di==0&&i==0,
                    skipMainHeader:di!=0,
                    mainHeader:"Re-Alligned Budget",
                    mainHeaderSpan:allDepts.reduce((a:any,b:any) => (a + b.operationUnits.filter((iit:any)=>this.selectedFields.includes('t'+iit.id)).length),0)+allDepts.filter((iid:any) => this.selectedFields.includes('d'+iid.id)).length,
                    hasHeader:i==0,
                    skipHeader:i!=0,
                    header:d.name,
                    headerSpan:showDeptSum? (allOperations.length+1):allOperations.length,
                    formatter:(value:any,key:any,item:any) => {
                        let totalBudget = 0
                        if(item.reAllignedBudgets)item.reAllignedBudgets.filter((rb:any) => rb.operationUnitId == t.id).forEach((trb:any) => totalBudget+=trb.total);                      
                        return totalBudget
                    }
                })
            })

            if(showDeptSum){
                fieldsToReturn.push({
                    key:"rbd"+d.id,
                    label:d.name + " Sum (K$)",
                    skipHeader:true,
                    skipMainHeader:true,
                    tdClass: 'project-report-table',
                    formatter:(value:any,key:any,item:any) => {
                        let totalBudget = 0
                        let departMentOperations = d.operationUnits.map((t:any) => t.id)
                        if(item.reAllignedBudgets)item.reAllignedBudgets.filter((rb:any) => departMentOperations.includes(rb.operationUnitId)).forEach((trb:any) => totalBudget+=trb.total);                      
                        return totalBudget
                    }
                })
            }
        })
        
        return fieldsToReturn
    }

    get sequence(){
        return this.$store.getters['sequencesModule/getSequence'](this.sequenceId)
    }

    get projects () {
        return this.$store.getters['projectModule/getProjectsForSequence'](this.sequenceId)
    }

    get getAllDepartments () {
        return this.$store.getters['departments/getAllDepartments']
    }

    get filteredSelectedProjects(){
        if(this.selectedFundingTranches.includes("UNDEFINED")){
            return this.selectedProjects.filter(p => p.funding?this.selectedFundingTranches.includes(p.funding.id):true)
        }else{
            return this.selectedProjects.filter(p => p.funding?this.selectedFundingTranches.includes(p.funding.id):false)
        }
    }

    getDepartments () {
        return this.$store.dispatch('departmentModule/getDepartments')
    }

    newTab () {
        var wnd = window.open("", "_blank", "scrollbars, menubar, toolbar, status") as any;
        const div = this.$refs.printDiv as any
        wnd.document.write(div.outerHTML);
        wnd.document.close();
        return false
    }
    printPDF  () {
        const printDiv = this.$refs.printDiv as any;
        const newWindow = window.open('') as any;
        newWindow.document.write(printDiv.outerHTML);
        newWindow.print();
        newWindow.close();
    }
    writeToExcel(filename = '') {
        var downloadLink;
        var dataType = 'application/vnd.ms-excel'
        var tableSelect = this.$refs.projtable as any;
        var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20')

        filename = '_excel_data.xls'

        downloadLink = document.createElement('a')
        document.body.appendChild(downloadLink)

        if (navigator.msSaveOrOpenBlob) {
            var blob = new Blob(['\ufeff', tableHTML], {
                type: dataType
            })
            navigator.msSaveOrOpenBlob(blob, filename)
        } else {
            downloadLink.href = 'data:' + dataType + ', ' + tableHTML
            downloadLink.download = filename
            downloadLink.click()
        }
    }
    close () {
        const modal = this.$refs.modal as any
        modal.hide()
    }

    setupFieldOptions(){
        this.tableOptions.push(...this.projectProperties.map(p=>({value:p.key,text:p.label})))
        this.selectedFields.push(...this.projectProperties.map(p=>p.key))
        this.sequence.departments.forEach((d:any) => {
            d.operationUnits.forEach((t:any,i:any,allOperations:Array<any>) => {
                this.tableOptions.push({
                    value:'t'+t.id,
                    text:t.name + "(K$)",
                })
                this.selectedFields.push('t'+t.id)
            })
            this.tableOptions.push({
                value:'d'+d.id,
                text:d.name + " Sum (K$)",
            })
            this.selectedFields.push('d'+d.id)
        })

        this.sequence.departments.forEach((d:any) => {
            d.operationUnits.forEach((t:any,i:any,allOperations:Array<any>) => {
                this.tableOptions.push({
                    value:'rbt'+t.id,
                    text:"ReAlligned Budget "+t.name + "(K$)",
                })
                this.selectedFields.push('rbt'+t.id)
            })
            this.tableOptions.push({
                value:'rbd'+d.id,
                text:d.name + " Sum (K$)",
            })
            this.selectedFields.push('rbd'+d.id)
        })
    }

    mounted () {
        this.projects.forEach((project: any) => {
            this.selectedProjects.push(project)
        })
        if (this.fundings.length === 0) {
            this.$store.dispatch('fundingsModule/fetchFundings').then(()=>{
                this.selectedFundingTranches = this.fundings.map((f:any) => f.id)
                this.selectedFundingTranches.push("UNDEFINED")
            })
        }else{
            this.selectedFundingTranches = this.fundings.map((f:any) => f.id)
            this.selectedFundingTranches.push("UNDEFINED")
        }
        this.getDepartments()
        this.setupFieldOptions()
    }
}
